import { SyntheticEvent, useState } from 'react'

import Emoji from 'common/emoji'

import Button, { ButtonProps, Variant } from '../button/Button'
import Modal from '../Modal'

import ValidationSlider from './ValidationSlider'

export interface ConfirmationModalProps {
  open: boolean
  onCancel: () => void
  isLoading?: boolean
  onConfirm: (e: SyntheticEvent<HTMLButtonElement, MouseEvent>) => void
  title: string
  emoji?: string
  hasConfirmationSlider?: boolean
  confirmationText: string
  cancelButtonText?: string
  confirmButtonText?: string
  confirmButtonProps?: ButtonProps
  'data-cy'?: string
  'data-testid'?: string
  confirmButtonVariant?: Variant
}

export const confirmModalText = {
  confirm: 'Yes, delete it!',
}

const ConfirmationModal = ({
  open,
  onCancel,
  isLoading,
  onConfirm,
  title,
  emoji = '😲',
  confirmationText,
  cancelButtonText = 'Noooo, cancel',
  confirmButtonText = confirmModalText.confirm,
  confirmButtonProps,
  hasConfirmationSlider = false,
  'data-cy': dataCy,
  'data-testid': dataTestId,
  confirmButtonVariant = 'danger',
}: ConfirmationModalProps) => {
  const [isValid, setIsValid] = useState(!hasConfirmationSlider)
  return (
    <Modal
      visible={open}
      centered
      closable={false}
      footer={null}
      data-cy={dataCy}
      data-testid={dataTestId}
    >
      <div className="flex">
        <Emoji className="mr-4 text-5xl" symbol={emoji} />
        <h1 className="mt-2 text-2xl font-bold text-coolGray-800">{title}</h1>
      </div>

      <div className="mt-4 mb-14 text-lg text-coolGray-500">
        {confirmationText}
        {hasConfirmationSlider ? (
          <div className="mt-8 mx-5">
            <ValidationSlider onChange={(value) => setIsValid(value === 100)} />
            <div
              style={{ marginTop: 26 }}
              className="text-center text-xs font-bold text-coolGray-800"
            >
              Drag the skull to right hand side ⇾
            </div>
          </div>
        ) : undefined}
      </div>

      <div className="flex justify-end">
        <Button
          ghost
          className="mr-4 text-base text-coolGray-400 border border-coolGray-100 "
          onClick={onCancel}
          data-testid="confirm-cancel-button"
          data-cy="confirm-cancel-button"
        >
          {cancelButtonText}
        </Button>

        <Button
          variant={confirmButtonVariant}
          onClick={onConfirm}
          loading={isLoading}
          disabled={!isValid}
          data-cy="confirm-confirm-button"
          {...confirmButtonProps}
        >
          {confirmButtonText}
        </Button>
      </div>
    </Modal>
  )
}

const ConfirmationModalWithResetState = (props: ConfirmationModalProps) => (
  <ConfirmationModal key={`${props.open}`} {...props} />
)
export default ConfirmationModalWithResetState
